const _temp0 = require("./cursor_build.png");
const _temp1 = require("./cursor_cancel.png");
const _temp2 = require("./cursor_move.png");
const _temp3 = require("./cursor_reflector.png");
module.exports = {
  "build": _temp0,
  "cancel": _temp1,
  "move": _temp2,
  "reflector": _temp3
}